// import apiClient from "./apiClient";

// export const request = async ({
//     method, url, data = {}, params = {}, headers = {}
// }: {
//     method: import("axios").Method; url: string; data?: any; params?: any; headers?: any
// }): Promise<any> => {
//     try {
//         const response = await apiClient({
//             method,
//             url,
//             data,
//             params,
//             headers
//         })

//         return response.data;
//     } catch (error: any) {
//         if (error.response) {
//             throw error.response.data.message;
//         } else if (error.request) {
//             throw new Error("No response received from server");
//         } else {
//             throw new Error("An error occur while making the request: " + error.message);
//         }
//     }
// }

import apiClient from "./apiClient";

export const request = async ({
  method,
  url,
  data = {},
  params = {},
  headers = {},
}: {
  method: import("axios").Method;
  url: string;
  data?: any;
  params?: any;
  headers?: any;
}): Promise<any> => {
  try {
    const response = await apiClient({
      method,
      url,
      data,
      params,
      headers,
    });

    return response.data;
  } catch (error: any) {
    let message = "Something went wrong";

    if (error.response) {
      message =
        error.response?.data?.message ||
        "Server responded with an error";
    } else if (error.request) {
    //   message = "Server is not responding. Please try again later.";
      message = "The server is waking up. This may take a few seconds, please try again shortly.";
    } else {
      message = error.message;
    }

    // ✅ return proper error
    throw new Error(message);
  }
};